import React from "react";

const Sidebar = () => {
  return (
    <div className="sidebar">
      <ul>
        <li>
          <a href="">Courses</a>
        </li>
        <li>
          <a href="">Assignments</a>
        </li>
        <li>
          <a href="">Grades</a>
        </li>
        <li>
          <a href="">Calendar</a>
        </li>
        <li>
          <a href="">Timeline</a>
        </li>
      </ul>
    </div>
  );
};

export default Sidebar;
